import { RootState } from '@store/store';

// Get job bulk apply feed.
export const getJobBulkApplyFeed = (state: RootState) => state.job.bulkApplyFeed;
